import React from "react";

function Linkes() {
  return (
    <div className="Linkes">
      <h2>
        ©2026 <span>Joe Programming Channel.</span> All rights reserved
      </h2>
    </div>
  );
}

export default Linkes;
